import { Link } from "react-router-dom"
import { useState,useEffect } from "react";
import styled from "styled-components"
import { HomeFilled,ShoppingCartOutlined,UserOutlined ,InfoCircleFilled } from "@ant-design/icons/lib/icons"
import { Badge } from 'antd';
const Nav = styled.div`
    width:18vw;
    height:110vh;
    padding:22vh 0;
    position:fixed;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:space-evenly;
    background-color:white;
    .nav-link{
        color:black;
        text-decoration:none;
        padding:2vh 2vw;
        border-radius:20px;
        border:1.5px solid white;
        display: flex;
        flex-direction:column;
        align-items:center;
        
        :hover{
            background-color:tomato;
            color:white;
            transition:0.25s all ease;
        }
        .nav-icon{
            font-size: 2vmax;
            margin-bottom:2vh;
            @media (max-width:1023px) and (min-width:768px){
                font-size: 3vmin;
            }
        }
        p{
            @media (max-width:1023px) and (min-width:768px){
                font-size: 1.5vmin;
            }
        }
    }
    @media (max-width:767px){
        display: none;
    }
    `
export default function Navbar(){
    return(
        <Nav>
            <Link to='/home' className="nav-link"><HomeFilled className="nav-icon"/><p>Trang chủ</p></Link>
            <Link to='/home/cart' className="nav-link"><ShoppingCartOutlined className="nav-icon"/><p>Giỏ hàng</p></Link>
            <Link to='/home/user' className="nav-link"><UserOutlined  className="nav-icon"/><p>Thông tin người dùng</p></Link>
        </Nav>
    )
}